import React, { useState, useEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { ReactSession } from 'react-client-session';
import { Markup } from 'interweave';

import classes from './Header.module.css'
import '../../../App.css';

const noAvatar = "https://hostpapasupport.com/knowledgebase/wp-content/uploads/2018/04/1-13.png";

function useWindowSize() {
  const [windowSize, setWindowSize] = useState([window.innerHeight, window.innerWidth]);

  useEffect(() => {
    function handleResize() {
      setWindowSize([window.innerHeight, window.innerWidth]);
    }
    window.addEventListener('resize', handleResize);
  }, []);

  return windowSize;
}

function Header() {
  const navigate = useNavigate();
  const [height, width] = useWindowSize(0);

  ReactSession.setStoreType("localStorage");
  const logged_user = ReactSession.get('logged_user');

  useEffect(()=> {
    !logged_user && navigate('/login');

    const themeType = localStorage.getItem('theme') || 'light-theme';
    document.body.classList.add(themeType);
  }, [])

  const toggleSidebar = () => {
      document.body.classList.toggle("full_width");
  }

  // console.log(`${height} - ${width}`);

  useEffect(() => {
    if (width < 768) {
      document.body.classList.add("full_width");
      document.body.classList.add("screen_sm");
    }else {
      document.body.classList.remove("full_width");
      document.body.classList.remove("screen_sm");
    }
  }, [width, height]);

  const toggleDropdown = () => {
    document.getElementsByClassName(classes.dropdown_menu)[0].classList.toggle("show");
  }

  return (
    <div className={classes.header_section}>
          <div className={classes.section_left}>
          <div className={classes.logo}>
            <Link to="/">
              <img src={`${process.env.REACT_APP_API_URL}/storage/uploads/wesharez-pl-png5e9ace7d1bbda.png`} alt="" />
            </Link>
          </div>
            <div className={classes.bar_icon}>
              <div className={classes.toggleBtn} onClick={toggleSidebar}>
                <span className={classes.app_icon}></span>
              </div>
            </div>
          </div>
          <div className={classes.section_right}>
            <div className={`${classes.dropdown}`} onClick={toggleDropdown}>
              <div className={classes.avatar}>
                {/* <img className="rounded-circle" src="https://assets.codepen.io/3306515/IMG_2025.jpg" alt="" /> */}
                {/* <img className="rounded-circle" src={ReactSession.get('avatar')} alt={ReactSession.get('name')} /> */}
                <img className="rounded-circle" src={ReactSession.get('avatar')} onError={e => {e.target.src = noAvatar}} alt={ReactSession.get('name')} />
              </div>
              <span className={classes.user_name}><Markup content={ReactSession.get('name')}></Markup></span>
              <div className={classes.caret_down}>
                <i className="fas fa-caret-down"></i>
              </div>
            </div>
            <div className={`dropdown-menu ${classes.dropdown_menu}`}>
              <Link className="dropdown-item" to={`/profile/${logged_user}/${ReactSession.get('name').toLowerCase().replace(/[^A-Z0-9]+/ig, "-")}`}><i className="fa-solid fa-user"></i> <Markup content={ReactSession.get('name')}></Markup></Link>
              <div className="dropdown-divider"></div>
              <Link className="dropdown-item" to="/dashboard/settings">
                <i className="fas fa-tools"></i> Account Setting
              </Link>
              <Link className="dropdown-item" to="/dashboard/settings/password">
                <i className="fas fa-unlock-alt"></i> Change password
              </Link>
              <div className="dropdown-divider"></div>
              <Link className="dropdown-item" to='/logout'>
                <i className="fas fa-sign-out-alt"></i> Logout
              </Link>
            </div>
          </div>
        </div>
  )
}

export default Header